import React from "react";
import Backdrop from "@mui/material/Backdrop";
import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

/** Result message shown after a bid. */
export default function BidResultBackdrop({
  errorResult,
  messageStatus,
  messageSuccess,
}) {
  return (
    <Backdrop className="single-product-bell-mt" open={messageStatus} sx={{ zIndex: 1300, color: "#fff" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          bgcolor: "rgba(0,0,0,0.7)",
          p: 4,
          borderRadius: 2,
          flexDirection: "column",
        }}
      >
        {errorResult === false ? (
          <PriorityHighIcon
            sx={{ fontSize: 60, color: "#f44336", mb: 1 }}
          />
        ) : (
          <CheckCircleIcon sx={{ fontSize: 60, color: "#00d09c", mb: 1 }} />
        )}

        <Typography variant="h6" sx={{ color: "#fff", fontWeight: "bold" }}>
          {messageSuccess}
        </Typography>
      </Box>
    </Backdrop>
  );
}
